import { defineCatalogue } from '../../i18n';

export const formCatalogue = defineCatalogue(
  {
    cancel: 'Cancelar',
    close: 'Fechar',
    'failure.title': 'Não foi possível salvar',
  },
  {
    cancel: 'Cancel',
    close: 'Close',
    'failure.title': 'Could not save',
  },
);

export const ft = formCatalogue.t;
